module.exports = __webpack_public_path__ + "img/step2.27bf82d3.svg";